// https://stackoverflow.com/a/13164238
const cookie = {
  write (name, value, days = 730, path = '/', domain) {
    const date = new Date()
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
    const expires = '; expires=' + date.toGMTString()
    let cookieValue = name + '=' + value + expires + '; path=' + path
    if (domain) {
      cookieValue = cookieValue + '; domain=' + domain
    }
    document.cookie = cookieValue
  },
  read (name) {
    const allCookie = '' + document.cookie
    const index = allCookie.indexOf(name)
    if (typeof name === 'undefined' || name === '' || index === -1) { return null }
    let ind1 = allCookie.indexOf(';', index)
    if (ind1 === -1) { ind1 = allCookie.length }
    return decodeURIComponent(allCookie.substring(index + name.length + 1, ind1))
  },
  remove (name) {
    if (this.read(name)) {
      this.write(name, '', -1, '/')
    }
  },
}

// https://stackoverflow.com/a/16427747
const testStorage = (type) => {
  const mod = 'modernizr'
  try {
    window[type + 'Storage'].setItem(mod, mod)
    window[type + 'Storage'].removeItem(mod)
    return true
  } catch (e) {
    return false
  }
}

module.exports = {
  local: testStorage('local'),
  session: testStorage('session'),
  get (key, type = 'local') {
    if (type === 'cookie') {
      return cookie.read(key)
    } else if (this[type]) {
      return window[type + 'Storage'].getItem(key)
    }
    return new Error()
  },
  set (key, value, type = 'local') {
    if (type === 'cookie') {
      return cookie.write(key, value)
    } else if (this[type]) {
      return window[type + 'Storage'].setItem(key, value)
    }
    return new Error()
  },
  unset (key, type = 'local') {
    if (type === 'cookie') {
      return cookie.remove(key)
    } else if (this[type]) {
      return window[type + 'Storage'].removeItem(key)
    }
    return new Error()
  },
}
